import React, { useEffect, useMemo, useState } from "react";

import { Box } from "@mui/material";
import { TextInputComponent } from "../../../../../../common/components";
import {
  cityOptions,
  stateOptions,
} from "../../../../../../utils/extractStateCityZipCode";
import SingleSelectAutocomplete from "../../single-option-select";
import "./address-filter.scss";

type Props = {
  namePrefix?: string;
  postCode?: string;
  disabled?: boolean;
  values: any;
  setAddress?: any;
  addressError?: string;
  setAddressError?: any;
};

const AddressFilter: React.FC<Props> = ({
  values,
  setAddress,
  addressError,
  setAddressError,
}) => {
  const countryOptions = [{ label: "United States", value: "United States" }];

  return (
    <>
      <Box
        className="address-details-content address-details-wrapper tenant-address-filter-wrapper assignment-rules-address-filter-wrapper"
        gap={3}
      >
        <Box className="address-content-header">
          <ul className="equal-width-list">
            <li className="list-item">
              <div className="country-dropdown address-dropdown">
                <SingleSelectAutocomplete
                  options={countryOptions}
                  selectedValue={
                    countryOptions.find(
                      (opt) => opt.value === values.country
                    ) || null
                  }
                  placeholder="Select Country"
                  onChange={(val: any) => {
                    setAddressError?.("");
                    setAddress?.((prev: any) => ({
                      ...prev,
                      country: val?.value || "",
                    }));
                  }}
                  noOptionsFoundText={"No matching countries found"}
                />
              </div>
            </li>
            <li className="list-item">
              <div className="state-dropdown address-dropdown">
                <SingleSelectAutocomplete
                  options={stateOptions}
                  selectedValue={
                    stateOptions.find((opt) => opt.value === values.state) ||
                    null
                  }
                  placeholder="Select State"
                  onChange={(val: any) => {
                    setAddressError?.("");
                    setAddress?.((prev: any) => ({
                      ...prev,
                      state: val?.value || "",
                    }));
                  }}
                  noOptionsFoundText={"No matching states found"}
                />
              </div>
            </li>
            <li className="list-item">
              <div className="city-dropdown address-dropdown">
                <SingleSelectAutocomplete
                  options={cityOptions}
                  selectedValue={
                    cityOptions.find((opt) => opt.value === values.city) || null
                  }
                  placeholder="Select City"
                  onChange={(val: any) => {
                    setAddressError?.("");
                    setAddress?.((prev: any) => ({
                      ...prev,
                      city: val?.value || "",
                    }));
                  }}
                  noOptionsFoundText={"No matching cities found"}
                />
              </div>
            </li>

            <li className="list-item postcode-input-field">
              <div className="tenant-filter-options-text-wrapper">
                <div className="filter-options-tenant-filters">
                  <TextInputComponent
                    type="text"
                    fieldName="postcode"
                    placeholder="Enter Zipcode"
                    value={values?.postcode}
                    onChange={(e: any) => {
                      setAddressError?.("");
                      let zip = e.target.value;
                      // Optional: filter out non-digits without blocking input
                      zip = zip.replace(/\D/g, "").slice(0, 5); // ✅ removes non-digits, trims to 5
                      setAddress?.((prev: any) => ({ ...prev, postcode: zip }));
                    }}
                    renderErrorMessage={false}
                  />
                </div>
              </div>
            </li>
            {addressError && (
              <div className="error-message">{addressError}</div>
            )}
          </ul>
        </Box>
      </Box>
    </>
  );
};

export default AddressFilter;
